import { Select } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Empresa } from '../../constants';

const { Tipo } = Empresa;

export default function SelectEmpresaTipo(props) {
  const { t } = useTranslation();

  const createOption = ({ id, label }) => <Select.Option value={id}>{t(label)}</Select.Option>;

  return (
    <Select {...props}>
      {createOption(Tipo.Associacao)}
      {createOption(Tipo.ConsorcioSociedades)}
      {createOption(Tipo.Cooperativa)}
      {createOption(Tipo.EntidadeEstrangeira)}
      {createOption(Tipo.EmpresarioIndividual)}
      {createOption(Tipo.Fundacao)}
      {createOption(Tipo.FundoDeInvestimento)}
      {createOption(Tipo.SociedadeEmContaDeParticipacao)}
      {createOption(Tipo.SociedadeLimitada)}
      {createOption(Tipo.SociedadePorAcoes)}
      {createOption(Tipo.SociedadeSimples)}
    </Select>
  );
}

SelectEmpresaTipo.propTypes = {
  value: PropTypes.oneOf([
    Tipo.SociedadeLimitada.id,
    Tipo.SociedadePorAcoes.id,
    Tipo.SociedadeSimples.id,
    Tipo.EmpresarioIndividual.id,
    Tipo.Associacao.id,
    Tipo.Fundacao.id,
    Tipo.SociedadeEmContaDeParticipacao.id,
    Tipo.Cooperativa.id,
    Tipo.FundoDeInvestimento.id,
    Tipo.EntidadeEstrangeira.id,
    Tipo.ConsorcioSociedades.id,
  ]),
  onChange: PropTypes.func,
};
